<template>
	<div>
		<template v-if="isLoaded">
			<div class="container has-text-centered">
				<h1 class="title is-1">
					{{ $t('piterkit') }}
				</h1>
				<h3 class="subtitle is-4 mb-5">
					{{ current_stage.title }}
				</h3>
			
				<template v-if="active_sessions.length == 0">
					<h4>
						{{ $t('warnings.no_open_sessions') }}
					</h4>
				</template>
				<template v-else>
					<h4>
						{{ $t('notifications.open_sessions') }}
					</h4>

					<div class="tile is-ancestor is-justify-content-center mt-5 has-text-left">

						<online-movie-session :movie_session="movie_session" v-for="movie_session in active_sessions" :key="'movie_session'+movie_session.id" />

					</div>
				</template>
			</div>
		</template>
	</div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios'
import OnlineMovieSession from './OnlineMovieSession'
import _ from 'lodash'

export default {
	name: 'StageFoyer',
	props: {
		stage: {
			required: true
		}
	},
	components: {
		OnlineMovieSession
	},
	data(){
		return {
			active_sessions: [],
			current_stage: null,
			isLoaded: false
		}
	},
	mounted(){
		this.getActiveSessions()

		if(window.Echo.connector.pusher.connection.state == 'unavailable'){
			setInterval(() => {
				this.getActiveSessions()
			}, 30000)
		} else {
			window.Echo.channel('movie-session-change-state').listen('MovieSessionChangeState', data => {
				if(
					data.payload.action == 'close_registration' || 
					data.payload.action == 'started' ||
					data.payload.action == 'open' ||
					data.payload.action == 'close' ||
					data.payload.action == 'viewing_ended'
				){
					let index = _.findIndex(this.active_sessions, as => {
						return as.id == data.payload.movie_session.id
					})

					if(index > -1){
						this.active_sessions.splice(index, 1)
					}
				} else if(data.payload.action == 'open_registration'){
					this.active_sessions.push(data.payload.movie_session)
				}
				//console.log(data.payload.action)
			})
		}
	},
	beforeUnmount(){
		window.Echo.channel('movie-session-change-state').stopListening('MovieSessionChangeState')
	},
	methods: {
		async getActiveSessions(){
			await axios.get(`${process.env.VUE_APP_API_LOCATION}/api/active_sessions/${this.stage}`).then(r => {
				this.active_sessions = r.data.movie_sessions
				this.current_stage = r.data.stage
				this.isLoaded = true
			})
		}
	}
}
</script>